// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sl-login-icon{width:24px;height:24px}", "",{"version":3,"sources":["webpack://./src/features/login/private/components/shared/Icon/Icon.scss"],"names":[],"mappings":"AAAA,eACI,UAAA,CACA,WAAA","sourcesContent":[".sl-login-icon {\n    width: 24px;\n    height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
